<div
  class="w-[min(20rem,calc(100vw-2rem))] overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">
  <div class="flex items-start gap-3 px-4 pt-4 pb-3">
    <span
      class="mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-xl bg-sky-50 text-sky-600"
      aria-hidden="true">
      <app-svg-icon src="assets/icons/database-outline.svg" [size]="18" />
    </span>

    <div class="min-w-0 flex-1">
      <div class="flex items-start justify-between gap-2">
        <div class="min-w-0">
          <p class="truncate text-sm font-semibold text-slate-950">
            @if (isLoading()) {
              Loading…
            } @else if (hasError()) {
              Record unavailable
            } @else {
              {{ collectionName() }}
            }
          </p>
          <p class="mt-0.5 text-[11px] leading-4 text-slate-500">
            Data Library · Record details
          </p>
        </div>
        <span
          class="shrink-0 rounded-md bg-violet-50 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-violet-700">
          Entity
        </span>
      </div>
    </div>
  </div>

  <div class="px-4 pb-4">
    @if (isLoading()) {
      <div
        class="rounded-xl border border-slate-100 bg-slate-50 px-3 py-4 text-center text-xs text-slate-500">
        Loading record…
      </div>
    } @else if (hasError()) {
      <div
        class="rounded-xl border border-amber-100 bg-amber-50 px-3 py-3 text-xs leading-5 text-amber-800">
        @if (fallbackDisplay()) {
          Could not load details for “{{ fallbackDisplay() }}”.
        } @else {
          Could not load this record.
        }
      </div>
    } @else {
      <div class="overflow-hidden rounded-xl border border-slate-200">
        @for (field of fields(); track field.key; let last = $last) {
          <div
            class="grid grid-cols-[minmax(0,7rem)_minmax(0,1fr)] items-stretch text-xs"
            [class.border-b]="!last"
            [class.border-slate-100]="!last">
            <div
              class="border-r border-slate-100 bg-slate-50 px-3 py-2.5 font-medium text-slate-500">
              {{ field.name }}
            </div>
            <div class="px-3 py-2.5 font-medium text-slate-900 break-words">
              {{ field.value }}
            </div>
          </div>
        } @empty {
          <div class="px-3 py-3 text-xs text-slate-500">No fields to show.</div>
        }
      </div>
    }
  </div>
</div>
